import type { ResumeProjectInput } from "@/lib/resume-utils";

export interface PortfolioProject extends ResumeProjectInput { logo?: string; preview?: string }

export function portfolioProjectKey(title: string): string {
  return title.toLowerCase().replace(/^the\s+/, "").replace(/[^a-z0-9]/g, "");
}

/** Local project additions supplement the CMS until its corresponding records exist. */
export function includeIndependentProjects<T extends PortfolioProject>(projects: T[]): PortfolioProject[] {
  const updated: PortfolioProject[] = projects.map(project => project.title === "KLOsystems" ? {
    ...project,
    description: [
      "Built the KLO Systems studio website with a product catalog, interactive demos, and consultation workflows for local businesses.",
      "Developed reusable interfaces for product discovery, service inquiries, and administration using Next.js and TypeScript.",
      "Showcases studio products including The Weekend Harvest, a hydroponic farm management application.",
    ],
  } : project);
  const existing = updated.find(project => portfolioProjectKey(project.title) === "weekendharvest");
  if (existing) return updated.map(project => project === existing ? { ...project, preview: "/projects/weekend-harvest-water.png" } : project);
  return [{
    title: "The Weekend Harvest", role: "Software Engineer", company: "KLO Systems",
    category: "personal", date: "In development", order: 100,
    description: [
      "Building a hydroponic farm management application with responsive interfaces for crop planning, nursery tracking, water readings, and production costs.",
      "Developed interactive farm workflows with React, Next.js, TypeScript, and Convex, alongside a conversational AI assistant that requests approval before saving changes.",
      "Designed desktop and mobile views for reservoir measurements, crop timelines, and daily farm operations.",
    ],
    techStack: ["Next.js", "React", "TypeScript", "Tailwind CSS", "Convex", "AI tool integration"],
    link: "https://theweekendharvest.com", logo: "/projects/weekend-harvest-logo.png", preview: "/projects/weekend-harvest-water.png",
  }, ...updated];
}
